<template>
<w-sliding-popup ref="slidingPopup" title="이벤트 상세정보" width="900px" :defaultContent="false">
  <div slot="content" class="event-popup-content">
    <el-table
      :data="tableData"
      height="100%"
      style="width: 100%"
      class="popup"
    >
      <el-table-column
        v-for="column in tableColumns"
        :key="column.key"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :align="column.align"
        :header-align="column.headerAlign"
      >
        <template slot-scope="scope">
          <w-eventlevel-cell v-if="column.scopedSlot === 'eventlevel-slot'" mini :eventlevel-id="scope.row.eventlevelId" />
          <!-- 이벤트 메시지 -->
          <span v-else-if="column.scopedSlot === 'event-message-slot'" @click="clickEventMessage(scope.row)" class="link">
            <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
              동적
            </div>
            {{scope.row.eventMessage}}
          </span>
          <!-- <span v-else-if="column.scopedSlot === 'event-message-slot'" @click="clickEventMessage(scope.row)" class="link">{{scope.row.eventMessage}}</span> -->
          <div v-else-if="column.scopedSlot === 'confirm-manager-slot'">
            <span v-if="scope.row.confirmManagerId">{{scope.row.confirmManagerId}} ( {{getDateFormatter(scope, scope, scope.row.confirmDatetime)}} )</span>
            <a v-else href="#" @click="clickConfirmManagerStatus(scope.row)">미확인</a>
          </div>
          <!-- 수동 해제 -->
          <el-button v-else-if="column.scopedSlot === 'release-slot'" size="mini" @click="clickReleaseButton(scope.row)">해제</el-button>
          <span v-else-if="isEmpty(column.scopedSlot)">{{convertValueByFormatter(column.formatter, scope.row[column.prop])}}</span>
        </template>
      </el-table-column>
    </el-table>
    <w-event-release-popup ref="eventReleasePopup" :event-data="eventData" @reload="loadData"></w-event-release-popup>
  </div>
</w-sliding-popup>
</template>

<script>
import DashboardConst from '@/constants/dashboard';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WidgetAPI from '@/api/dashboard/widget';
import TroubleShootingAPI from '@/api/event/trouble-shooting';
import { isEmpty } from '@/utils/basic';
import { getDateToString, getDuration } from '@/utils/date';
import { openFaultAnalysisPopup } from '@/utils/event';
import isNil from 'lodash/isNil';
import { EMPTY_TEXT } from '@/utils/string';
import WEventReleasePopup from '@/views/event/event-status/popup/EventReleasePopup';

export default {
  name: 'WEventListPopup',
  components: {
    WEventlevelCell,
    WEventReleasePopup,
  },
  data() {
    return {
      isEmpty,
      tableData: [],
      eventData: null,
      params: {},
      tableColumns: [
        {
          prop: 'eventlevelId',
          label: '등급',
          key: 'eventlevelId',
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'left',
          columnKey: 'eventlevelId',
          className: 'eventlevel',
          width: 70,
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          key: 'managetypeName',
          headerAlign: 'left',
          align: 'left',
          formatter: 'managetypeName',
          width: 80,
        },
        {
          prop: 'objName',
          label: '대상',
          key: 'objName',
          headerAlign: 'left',
          align: 'left',
          formatter: 'eventTargetName',
          width: 120,
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          key: 'eventMessage',
          headerAlign: 'left',
          align: 'left',
          scopedSlot: 'event-message-slot',
        },
        {
          prop: 'checkDatetime',
          label: '최초발생시각',
          key: 'firstCheckDatetime',
          headerAlign: 'left',
          align: 'left',
          formatter: 'dateFormatter',
          width: 100,
        },
        {
          prop: 'checkDatetime',
          label: '지속시간',
          key: 'durationCheckDatetime',
          headerAlign: 'left',
          align: 'left',
          formatter: 'eventDuration',
          width: 100,
        },
        {
          prop: 'confirmManagerId',
          label: '확인자',
          key: 'confirmManagerId',
          headerAlign: 'left',
          align: 'center',
          scopedSlot: 'confirm-manager-slot',
          width: 90,
        },
        {
          label: '수동 해제',
          key: 'release',
          headerAlign: 'left',
          align: 'center',
          scopedSlot: 'release-slot',
          width: 75,
        },
      ],
    };
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.EVENT_LIST, this.open);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.EVENT_LIST, this.open);
  },
  methods: {
    open(params) {
      this.initData();
      this.params = params;
      this.loadData();
      this.$refs.slidingPopup.open();
    },
    close() {
      this.initData();
      this.$refs.slidingPopup.close();
    },
    initData() {
      this.tableData = [];
      this.eventData = null;
      this.params = {};
    },
    loadData() {
      const { managetypeId, managetypeKey, objIds, objTotal, rscTotal, rscInfoList, rscKeyInfoList, eventlevelType, eventlevelIds } = this.params;
      WidgetAPI.getEventStatusListData(managetypeId, managetypeKey, objIds, objTotal, rscTotal, rscInfoList, rscKeyInfoList, eventlevelType, eventlevelIds).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
        }
      });
    },
    convertValueByFormatter(formatter, value) {
      if (formatter === 'dateFormatter') {
        if (!isNil(value)) {
          return getDateToString(value);
        }
        return EMPTY_TEXT;
      } else if (formatter === 'eventDuration') {
        let diffTime = Math.floor(new Date().getTime() - value);
        diffTime = diffTime > 0 ? diffTime : 0;
        return getDuration(diffTime);
      } else if (formatter === 'emptyText') {
        if (!isNil(value)) {
          return value;
        }
        return EMPTY_TEXT;
      }
      return value;
    },
    clickEventMessage(selectedEventRow) {
      openFaultAnalysisPopup(selectedEventRow.eventSeqNumber);
    },
    clickConfirmManagerStatus(row) {
      // EventCommonTable.vue에서 가져온 함수
      const params = {
        seqNumber: row.eventSeqNumber,
      };
      // 미확인에 대한 장애티켓을 확인으로 처리 - MessageBox 적용 유무?
      TroubleShootingAPI.setConfirmManagerId(params).then(() => {
        this.loadData();
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    clickReleaseButton(row) {
      this.eventData = {
        objId: row.objId || -1,
        targetInfo: row.objName || '',
        hashkeyIdString: row.hashkeyIdString || '',
        eventMessage: row.eventMessage || '',
        eventlevelName: row.eventlevelName || '',
        managetypeId: row.managetypeId || '',
        managetypeName: row.managetypeName || '',
        rsctypeId: row.rsctypeId || '',
        rsctypeName: row.rsctypeName || '',
        rscId: row.rscId || '',
        rscKey: row.rscKey || '_',
        troubleStatusName: row.troubleStatusName || '',
        releaseMessage: null,
        firstSeqNumber: row.firstSeqNumber,
      };
      this.$refs.eventReleasePopup.$refs.slidingPopup.visible = true;
    },
  },
};
</script>

<style lang="scss">
.event-popup-content {
  height: 100%;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/EventListPopup.vue